import type { Socket } from 'socket.io-client'
import { createSocket } from '@/lib/player-socket'

let playerSocket: Socket | null = null
let playerSocketToken: string | null = null

/** Default Socket.IO namespace (`/`) — used for app-wide events like `balanceUpdate`. */
export function getPlayerSocket(token: string): Socket {
	if (!token) {
		throw new Error('getPlayerSocket requires a JWT token')
	}

	if (playerSocket && playerSocketToken !== token) {
		disconnectPlayerSocket()
	}

	if (!playerSocket) {
		playerSocket = createSocket({
			namespace: '',
			auth: { token },
			autoConnect: false,
		})
		playerSocketToken = token
	}

	// Keep handshake auth in sync (backend joins `player:{id}` only when JWT is valid).
	playerSocket.auth = { token }

	if (!playerSocket.connected) {
		playerSocket.connect()
	}

	return playerSocket
}

export function disconnectPlayerSocket(): void {
	if (!playerSocket) {
		return
	}

	playerSocket.removeAllListeners()
	playerSocket.disconnect()
	playerSocket = null
	playerSocketToken = null
}
